import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4451324e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "smstemplates" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "SMS Templates")
], -1))
const _hoisted_4 = { class: "col-sm-6 text-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" }, null, -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Report Type", -1))
const _hoisted_10 = { class: "col-10" }
const _hoisted_11 = { class: "col-2" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Default", -1))
const _hoisted_14 = { class: "col-sm-10" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Target", -1))
const _hoisted_18 = { class: "col-10" }
const _hoisted_19 = { class: "col-3" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Chron Order", -1))
const _hoisted_22 = { class: "col-10" }
const _hoisted_23 = { class: "col-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No sms templates found", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "table table-hover",
  style: {"padding-bottom":"60px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "25%" }, "Title"),
  /*#__PURE__*/_createElementVNode("th", { width: "8%" }, "Default"),
  /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Report Type"),
  /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Target"),
  /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Chron Order"),
  /*#__PURE__*/_createElementVNode("th", { width: "7%" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
  ])
], -1))
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "align-middle" }
const _hoisted_32 = { class: "align-middle" }
const _hoisted_33 = { class: "multiselecttags" }
const _hoisted_34 = {
  key: 0,
  class: "multiselecttag"
}
const _hoisted_35 = { class: "align-middle" }
const _hoisted_36 = { class: "multiselecttags" }
const _hoisted_37 = { class: "align-middle" }
const _hoisted_38 = { class: "multiselecttags" }
const _hoisted_39 = { class: "align-middle" }
const _hoisted_40 = { class: "multiselecttags" }
const _hoisted_41 = { class: "align-middle text-right" }
const _hoisted_42 = { class: "list-unstyled mb-0" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]

import { ref, computed, onMounted, inject } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { SMSTemplate } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'SMSTemplates',
  setup(__props) {

const store = useStore();
const router = useRouter();
const toasted = useToast();

const hasBlockingRequests = computed(
  () => store.getters["app/hasBlockingRequests"] as boolean
);
const smstemplates = computed(
  (): SMSTemplate[] => store.getters["smstemplates/list"]
);
const chroneoptions = ref([]);
const reporttypeoptions = ref([]);
const smstemplateslist = ref([]);
const targetoptions = ref([]);
const defaultdata = ref("All");
const targetList: string[] = [
  "Booked By",
  "Data Entry",
  "Managed Client",
  "Non-Managed Client",
  "Tenant",
  "Landlord",
  "Invoice",
];
const defaultlist: string[] = ["All", "Default", "Non-default"];
const chronorderList: string[] = [
  "Initial confirmation",
  "First Chaser",
  "Second Chaser",
  "Third Chaser",
  "Fourth Chaser",
  "Fifth Chaser",
  "Sixth Chaser",
  "Last Minute",
  "Reminder",
  "Change Of Date",
  "Restore Booking",
  "Confirmed",
  "Not Confirmed",
  "Delete Booking",
  "Correspondance/Feedback to Client",
  "Issue Report",
];
const jobtypelist = computed(() => store.getters["diary/jobtypelist"]);
const targetoptionsData = computed({
  get: () => targetoptions.value,
  set: (val: string[]) => addTargetData(val),
});
const reporttypeoptionsData = computed({
  get: () => reporttypeoptions.value,
  set: (val: string[]) => addReportType(val),
});
const chroneoptionsData = computed({
  get: () => chroneoptions.value,
  set: (val: string[]) => addChrone(val),
});
const deleteSMSTemplate = async (smstemplate: SMSTemplate) => {
  await store.dispatch("smstemplates/deleteSMSTemplate", smstemplate);
};

const actProperty: any = inject("actProperty");

onMounted(async () => {
  await store.dispatch("smstemplates/getSMSTemplates");
  smstemplateslist.value = smstemplates.value;
});

const edit = (smstemplate: SMSTemplate) => {
  if ("id" in smstemplate) {
    router.push({
      name: "smstemplate",
      params: { id: smstemplate.id },
    });
  } else {
    actProperty.displayError("Error");
  }
};

const remove = async (smstemplate: SMSTemplate) => {
  actProperty
    .confirmPrompt()
    .then(() => deleteSMSTemplate(smstemplate))
    .then(() => toasted.success("SMSTemplate deleted"))
    .catch((err: any) => actProperty.displayError(err));
};
const addReportType = async (data: string[]) => {
  reporttypeoptions.value = data;
  filterData();
};
const defaultfn = computed({
  get: () => defaultdata.value,
  set: (val: string) => {
    defaultdata.value = val;
    filterData();
  },
});
const addTargetData = async (data: string[]) => {
  targetoptions.value = data;
  filterData();
};
const addChrone = async (data: string[]) => {
  chroneoptions.value = data;
  filterData();
};
const clearDefault = async (data: string) => {
  defaultdata.value = "All";
  filterData();
};
const clearfilter = () => {
  reporttypeoptions.value = [];
  targetoptions.value = [];
  chroneoptions.value = [];
  defaultdata.value = "All";
  smstemplateslist.value = smstemplates.value;
};
const filterData = () => {
  smstemplateslist.value = smstemplates.value.filter((f: SMSTemplate) => {
    // Check if chroneoptions.value has any selected options
    const chronFilterActive = chroneoptions.value.length > 0;

    // Check if targetoptions.value has any selected options
    const targetFilterActive = targetoptions.value.length > 0;

    // Check if reporttypeoptions.value has any selected options
    const reporttypeoptionsActive = reporttypeoptionsData.value.length > 0;

    // Check if defaultfn.value is not undefined or empty
    let setDefault = false;
    if (defaultfn.value === "All") {
      setDefault = undefined;
    } else if (defaultfn.value === "Default") {
      setDefault = true;
    } else {
      setDefault = false;
    }
    const defaultFilterActive = setDefault !== undefined;
    return (
      (!defaultFilterActive || f.defaulttemplate === setDefault) &&
      (!chronFilterActive ||
        f.chronorder.some((chron) => chroneoptions.value.includes(chron))) &&
      (!targetFilterActive ||
        f.target.some((target) => targetoptions.value.includes(target))) &&
      (!reporttypeoptionsActive ||
        f.reporttypes.some((report) =>
          reporttypeoptionsData.value.includes(report)
        ))
    );
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "btn btn-lg btn-primary",
            to: "/smstemplate/new"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" New ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_multiselect_text, {
                modelValue: reporttypeoptionsData.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reporttypeoptionsData).value = $event)),
                options: jobtypelist.value,
                multiple: "",
                "close-on-select": false,
                allowEmpty: true,
                taggable: "",
                onTag: addReportType
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_singleselect_text, {
                modelValue: defaultfn.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((defaultfn).value = $event)),
                options: defaultlist,
                "allow-empty": false,
                taggable: false
              }, _createSlots({ _: 2 }, [
                (defaultfn.value)
                  ? {
                      name: "clear",
                      fn: _withCtx(() => [
                        _createElementVNode("i", {
                          onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (clearDefault()), ["prevent","stop"])),
                          class: "multiselect__clear fa fa-times",
                          "aria-label": "Clear Default"
                        }, null, 32)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_multiselect_text, {
                modelValue: targetoptionsData.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((targetoptionsData).value = $event)),
                options: targetList,
                multiple: "",
                "close-on-select": false,
                allowEmpty: true,
                taggable: "",
                onSelect: filterData
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_multiselect_text, {
                modelValue: chroneoptionsData.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((chroneoptionsData).value = $event)),
                options: chronorderList,
                multiple: "",
                "close-on-select": false,
                allowEmpty: true,
                taggable: "",
                onSelect: filterData
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (clearfilter()), ["prevent"]))
          }, [
            _hoisted_24,
            _createTextVNode(" Clear ")
          ])
        ])
      ])
    ]),
    (!smstemplateslist.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
      : (_openBlock(), _createElementBlock("table", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smstemplateslist.value, (smstemplate) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: smstemplate.id,
                onClick: ($event: any) => (edit(smstemplate))
              }, [
                _createElementVNode("td", _hoisted_31, _toDisplayString(smstemplate.title), 1),
                _createElementVNode("td", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, [
                    (smstemplate.defaulttemplate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Default"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smstemplate.reporttypes, (reporttype) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "multiselecttag",
                        key: reporttype
                      }, _toDisplayString(reporttype), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smstemplate.target, (t) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "multiselecttag",
                        key: t
                      }, _toDisplayString(t), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smstemplate.chronorder, (c) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "multiselecttag",
                        key: c
                      }, _toDisplayString(c), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_41, [
                  _createElementVNode("ul", _hoisted_42, [
                    _createElementVNode("li", {
                      class: "list-item",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-danger",
                        onClick: ($event: any) => (remove(smstemplate))
                      }, _hoisted_45, 8, _hoisted_43)
                    ])
                  ])
                ])
              ], 8, _hoisted_30))
            }), 128))
          ])
        ]))
  ]))
}
}

})